export default {"src":"https://webcdn.trailways.ca/_next/static/media/bus-stop.e89a2e04.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};